/*
 * @Author: wsx
 * @Date: 2022-02-24 11:33:34
 * @LastEditTime: 2022-03-01 11:40:43
 * @Description: 首页图标
 * @FilePath: \hz-digital-twin\src\views\Home\echart.ts
 */
import * as echarts from 'echarts'
import _ from 'lodash'

// type EChartsOption = echarts.EChartsOption;
// 人员图表
export const personCharts = () => {
    const offsetX = 8
    const offsetY = 5
      // 绘制左侧面
    const CubeLeft = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function(ctx, shape) {
          // 会canvas的应该都能看得懂，shape是从custom传入的
          const xAxisPoint = shape.xAxisPoint
            // console.log(shape);
          const c0 = [shape.x, shape.y]
          const c1 = [shape.x - offsetX, shape.y - offsetY]
          const c2 = [xAxisPoint[0] - offsetX, xAxisPoint[1] - offsetY]
          const c3 = [xAxisPoint[0], xAxisPoint[1]]

          ctx.moveTo(c0[0], c0[1])
          ctx.lineTo(c1[0], c1[1])
          ctx.lineTo(c2[0], c2[1])
          ctx.lineTo(c3[0], c3[1])
          ctx.closePath()
        }
      })
      // 绘制右侧面
    const CubeRight = echarts.graphic.extendShape({
        shape: {
          x: 0,
          y: 0
        },
        buildPath: function(ctx, shape) {
          const xAxisPoint = shape.xAxisPoint
          const c1 = [shape.x, shape.y]
          const c2 = [xAxisPoint[0], xAxisPoint[1]]
          const c3 = [xAxisPoint[0] + offsetX, xAxisPoint[1] - offsetY]
          const c4 = [shape.x + offsetX, shape.y - offsetY]

          ctx.moveTo(c1[0], c1[1])
          ctx.lineTo(c2[0], c2[1])
          ctx.lineTo(c3[0], c3[1])
          ctx.lineTo(c4[0], c4[1])
          ctx.closePath()
        }
      })
      // 绘制顶面
    const CubeTop = echarts.graphic.extendShape({
      shape: {
        x: 0,
        y: 0
      },
      buildPath: function(ctx, shape) {
        const c1 = [shape.x, shape.y]
        const c2 = [shape.x + offsetX, shape.y - offsetY] // 右点
        const c3 = [shape.x, shape.y - offsetX]
        const c4 = [shape.x - offsetX, shape.y - offsetY]

        ctx.moveTo(c1[0], c1[1])
        ctx.lineTo(c2[0], c2[1])
        ctx.lineTo(c3[0], c3[1])
        ctx.lineTo(c4[0], c4[1])
        ctx.closePath()
      }
    })
    echarts.graphic.registerShape('CubeLeft', CubeLeft)
    echarts.graphic.registerShape('CubeRight', CubeRight)
    echarts.graphic.registerShape('CubeTop', CubeTop)
    const MAX = [10, 80, 60, 40, 30, 36, 30]
    const VALUE = [5, 60, 40, 20, 20, 26, 10]

    const legendData = [{
        name: '进',
        textStyle: {
          color: '#ccc'
        },
        itemStyle: {
          color: '#7ecef4'
        }
      },
      {
        name: '出',
        textStyle: {
          color: '#ccc'
        },
        itemStyle: {
          color: '#00a0e9'
        }
      }
    ]

    return {
      title: {
        text: '单位/人',
        textStyle: {
          fontSize: 12,
          color: '#fff'
        },
        left: 8,
        top: 3
      },
      color: ['#7ecef4', '#00a0e9'],
      legend: {
        icon: 'circle',
        itemWidth: 10,
        itemHeight: 10,
        selectedMode: false, // 图例点击失效
        right: 10,
        top: 3,
        textStyle: {
          color: '#ffff',
          fontSize: 12
        },
        itemStyle: {

        },
        data: legendData
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        borderColor: 'rgba(255,255,255,.3)',
        backgroundColor: 'rgba(13,5,30,.6)',
        textStyle: {
          color: 'white' // 设置文字颜色
        },
        borderWidth: 1,
        padding: 5,
        formatter: function(parms) {
          const str =
            parms[0].name +
            '</br>' +
            parms[0].marker +
            parms[0].seriesName +
            '：' +
            parms[1].value +
            '</br>' +
            parms[1].marker +
            parms[1].seriesName +
            '：' +
            (parms[0].value - parms[1].value) +
            '</br>'
          return str
        }
      },
      grid: {
        left: 15,
        right: 20,
        bottom: 0,
        top: 33,
        containLabel: true
      },
      xAxis: {
        type: 'category',
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: '#2B7BD6'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          interval: 0,
          fontSize: 12,
          rotate: 30,
          color: '#fff'
        },
        data: ['01/01', '01/02', '01/03', '01/04', '01/05', '01/06', '01/07']
      },
      yAxis: {
        type: 'value',
        axisLine: {
          show: true,
          lineStyle: {
            width: 2,
            color: '#2B7BD6'
          }
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(43, 174 , 251, 0.15)'
          }
        },
        axisTick: {
          show: false
        },
        axisLabel: {
          fontSize: 12,
          color: '#fff'
        }
        // boundaryGap: ['20%', '20%'],
      },
      series: [{
          type: 'custom',
          name: '进',
          renderItem: function(_params, api) {
            const location = api.coord([api.value(0), api.value(1)])
            return {
              type: 'group',
              children: [{
                  type: 'CubeLeft',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1],
                    xAxisPoint: api.coord([api.value(0), 0])
                  },
                  style: {
                    fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#7ecef4'
                      },
                      {
                        offset: 1,
                        color: '#63c7f7'
                      }
                    ])
                  }
                },
                {
                  type: 'CubeRight',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1],
                    xAxisPoint: api.coord([api.value(0), 0])
                  },
                  style: {
                    fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#7ecef4'
                      },
                      {
                        offset: 1,
                        color: '#63c7f7'
                      }
                    ])
                  }
                },
                {
                  type: 'CubeTop',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1],
                    xAxisPoint: api.coord([api.value(0), 0])
                  },
                  style: {
                    fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#78c3e7'
                      },
                      {
                        offset: 1,
                        color: '#7ecef4'
                      }
                    ])
                  }
                }
              ]
            }
          },

          animation: true,
          data: MAX
        },
        {
          type: 'custom',
          name: '出',
          renderItem: (_params, api) => {
            const location = api.coord([api.value(0), api.value(1)])
            return {
              type: 'group',
              children: [{
                  type: 'CubeLeft',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1],
                    xAxisPoint: api.coord([api.value(0), 0])
                  },
                  style: {
                    fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#00a0e9'
                      },
                      {
                        offset: 1,
                        color: '#0073a7'
                      }
                    ])
                  }
                },
                {
                  type: 'CubeRight',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1],
                    xAxisPoint: api.coord([api.value(0), 0])
                  },
                  style: {
                    fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#00a0e9'
                      },
                      {
                        offset: 1,
                        color: '#0073a7'
                      }
                    ])
                  }
                },
                {
                  type: 'CubeTop',
                  shape: {
                    api,
                    xValue: api.value(0),
                    yValue: api.value(1),
                    x: location[0],
                    y: location[1],
                    xAxisPoint: api.coord([api.value(0), 0])
                  },
                  style: {
                    fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [{
                        offset: 0,
                        color: '#00a0e9'
                      },
                      {
                        offset: 1,
                        color: '#058acc'
                      }
                    ])
                  }
                }
              ]
            }
          },
          data: VALUE
        }
      ]
    }
  }
  // 车辆图表
export const carCharts = () => {
    return {
      title: {
        text: '单位/人',
        textStyle: {
          fontSize: 12,
          color: '#fff'
        },
        left: 8,
        top: 3
      },
      color: ['#ffcd00', '#2e8ec8'],
      legend: {
        right: 0,
        icon: 'circle',

        itemWidth: 10,
        itemHeight: 10,
        textStyle: {
          color: '#FFF'
        }
      },
      tooltip: {
        trigger: 'axis',
        axisPointer: {
          type: 'shadow'
        },
        borderColor: 'rgba(255,255,255,.3)',
        backgroundColor: 'rgba(13,5,30,.6)',
        textStyle: {
          color: 'white' // 设置文字颜色
        },
        borderWidth: 1,
        padding: 5,
        formatter: function(parms) {
          let str =
            parms[0].name +
            '</br>' +
            parms[0].marker +
            parms[0].seriesName +
            '：' +
            parms[0].value +
            '</br>'
          if (parms[1]) {
            str += parms[1].marker +
              parms[1].seriesName +
              '：' +
              parms[1].value[2] +
              '</br>'
            return str
          }
          return str
        }
      },
      dataset: {
        source: [
          ['product', '1月', '2月', '3月', '4月', '5月', '6月'],
          ['进', 56, 82, 88, 70, 53, 85],
          ['出', 51, 51, 55, 53, 73, 68]
        ]
      },
      xAxis: {
        type: 'category',

        axisLine: {
          show: false
        },
        axisLabel: {
          interval: 0,
          fontSize: 12,
          color: '#fff'
        }
      },
      yAxis: {
        gridIndex: 0,
        axisLine: {
          show: false
        },
        splitLine: {
          show: true,
          lineStyle: {
            color: 'rgba(43, 174 , 251, 0.15)'
          }
        },
        axisLabel: {
          color: '#fff'
        }
      },
      grid: {
        top: 33,
        left: 10,
        bottom: 0,
        right: 10,
        containLabel: true
      },
      series: [{
          type: 'line',
          smooth: true,
          lineStyle: {
            color: '#fecd02'
          },
          showSymbol: false,
          seriesLayoutBy: 'row',
          emphasis: { focus: 'series' }
        },
        {
          type: 'line',
          smooth: true,
          lineStyle: {
            color: '#31abf5'
          },
          showSymbol: false,
          seriesLayoutBy: 'row',
          emphasis: { focus: 'series' }
        }
      ]
    }
  }
  // 场地图表
export const fieldEcharts = () => {
    const option = {
      total: 78,
      data: [
        { value: 10, name: '使用' },
        { value: 73, name: '预约' },
        { value: 58, name: '空闲' }
      ]
    }
    return {
      color: ['#14e7d8 ', '#91c8ff', '#e2deba'],
      title: {
        text: `{value|${option.total}}`,
        subtext: '{label|事件总量}',
        left: 'center',
        top: 'center',
        textStyle: {
          rich: {
            value: {
              fontSize: 26,
              fontWeight: 100,
              lineHeight: 20,
              fontFamily: 'YouSheBiaoTiHei',
              color: '#ebfd07',
              padding: [0, 0, 20, 0]
            }
          }
        },
        subtextStyle: {
          rich: {
            label: {
              color: '#ffffff',
              fontWeight: 'bold',
              fontSize: 14,
              padding: [35, 0, 80, 0]
            }
          }
        }
      },
      legend: {
        show: false
      },
      series: [{
          name: 'Access From',
          type: 'pie',
          radius: ['55%', '85%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          labelLine: {
            show: false
          },
          data: option.data
        },
        {
          name: 'Access From',
          type: 'pie',
          radius: ['55%', '65%'],
          avoidLabelOverlap: false,
          label: {
            show: false,
            position: 'center'
          },
          labelLine: {
            show: false
          },
          data: [
            { value: 1, name: 'Search', itemStyle: { color: 'rgba(0,0,0,0.2)' } }
          ]
        }
      ]
    }
  }
  // 重点人员图表
export const keyPersonEcharts = () => {
  // 重点人员饼图
  function _pie2() {
    const dataArr = [];
    for (var i = 0; i < 8; i++) {
      if (i % 2 === 0) {
        dataArr.push({
          name: (i + 1).toString(),
          value: 35,
          itemStyle: {
            normal: {
              color: "rgba(112,180,248,1)",
            },
          },
        });
      } else {
        dataArr.push({
          name: (i + 1).toString(),
          value: 30,
          itemStyle: {
            normal: {
              color: "rgba(0,0,0,0)",
            },
          },
        });
      }
    }
    return dataArr;
  }
  const colorList = ["#3d8eb7", "#5dc8d8", "#ecab3c"];
  return {
    title: {
      text: "",
      x: "center",
      y: "center",
      textStyle: {
        fontSize: 13,
        color: "#facd2b",
      },
    },
    color: colorList,
    tooltip: {
      trigger: "item",
      formatter: "{b}:{c} ({d}%)",
      // confirm: true
    },
    series: [{
        name: "访问来源",
        type: "pie",
        radius: ["30%", "55%"],
        center: ["50%", "50%"],
        data: [
          { value: 30, name: "涉黄" },
          { value: 15, name: "前科" },
          { value: 55, name: "涉毒" },
          { value: 55, name: "在逃" },
        ],
        label: {
          normal: {
            color: "#fff",
            formatter: (params) => {
              return (
                "{name|" +
                params.name +
                "}" +
                '' +
                // "{percent|" +
                // params.percent.toFixed(0) +
                // "}" +
                // "%\n{hr|}"
                ''
              );
            },
            padding: 0,
            rich: {
              name: {
                fontSize: 13,
                lineHeight: 25,
              },
              percent: {
                fontSize: 14,
              },
              hr: {
                // 中间线
                borderColor: "#46e6c3",
                width: "100%",
                borderWidth: 1,
                height: 0,
              },
            },
            // position: "inside"
          },
        },
        labelLine: {
          length: 33,
          length2: 0,
          lineStyle: {
            color: "#46e6c3",
            width: 2,
          },
        },
        emphasis: {
          itemStyle: {
            shadowBlur: 10,
            shadowOffsetX: 0,
            shadowColor: "rgba(0, 0, 0, 0.5)",
          },
        },
      },
      {
        type: "pie",
        zlevel: 2,
        silent: true,
        center: ["50%", "50%"],
        radius: ["60%", "63%"],
        startAngle: 50,
        hoverAnimation: false,
        label: {
          normal: {
            show: false,
          },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        data: _pie2(),
      },
      {
        type: "pie",
        zlevel: 3,
        silent: true,
        center: ["50%", "50%"],
        radius: ["60%", "61%"],
        label: {
          normal: {
            show: false,
          },
        },
        labelLine: {
          normal: {
            show: false,
          },
        },
        data: _pie2(),
      },
    ],
  };
}

// 碳排放图标
export const carbonEmission = () => {
    return {
      title: {
        text: '预警总量',
        left: 'center',
        bottom: 5,
        textStyle: {
          color: '#ffffff',
          fontSize: 14,
          fontWeight: 100
        }
      },
      series: [{
        type: 'gauge',
        name: '预警总量',
        startAngle: 220,
        endAngle: -40,
        min: 0,
        max: 360,
        radius: '80%',
        splitNumber: 12,
        itemStyle: {
          color: { // 外层圆环底色
            type: 'linear',
            x: 0,
            y: 0,
            x2: 0,
            y2: 1.8,
            colorStops: [{
              offset: 0.75, // 设置成1下面也会显示
              color: '#4734f8' // 0% 处的颜色
            }, {
              offset: 0,
              color: '#54fdf1' // 100% 处的颜色
            }]
          },
          shadowColor: 'rgba(0,138,255,0.45)',
          shadowBlur: 10,
          shadowOffsetX: 2,
          shadowOffsetY: 2
        },
        progress: {
          show: true,
          roundCap: true,
          width: 6
        },
        axisLine: {
          roundCap: true,
          lineStyle: {
            width: 6
          }
        },
        pointer: { show: false },
        axisTick: { show: false },
        splitLine: { show: false },
        axisLabel: { show: false },
        title: { show: false },
        detail: {
          width: '60%',
          lineHeight: 24,
          offsetCenter: [0, '10%'],
          valueAnimation: true,
          formatter: function(value) {
            return `{value|${value.toFixed(0)}}`
          },
          rich: {
            value: {
              fontSize: 40,
              color: '#54fdf1'
            },
            unit: {
              fontSize: 14,
              color: '#54fdf1',
              padding: [0, 0, 0, 0]
            }
          }
        },
        data: [{
          value: 200
        }]
      }]
    }
  }
  // 区域安全图
export const areaSafety = () => {
  var dataname = ["安防设施", "力量装备", "研判预警", "设备告警", "实有警情"];
  var datamax = [20, 20, 20, 20, 20];
  var datavaule = [10, 16, 20, 15, 12];

  var indicator = [];
  for (var i = 0; i < dataname.length; i++) {
    indicator.push({
      name: dataname[i],
      max: datamax[i],
    });
  }

  function contains(arrays, obj) {
    var i = arrays.length;
    while (i--) {
      if (arrays[i] === obj) {
        return i;
      }
    }
    return false;
  }
  return {
    tooltip: {
      show: false,
      trigger: "item",
    },
    radar: {
      center: ["50%", "50%"],
      radius: "65%",
      startAngle: 240,
      splitNumber: 5,
      splitArea: {
        areaStyle: {
          color: [
            "rgba(255,255 ,255,0.1  )",
            // "rgb(55 190 239)",
            // "rgb(112 208 243)",
            // "rgb(159 219 241)",
            // "rgb(191 225 237)",

            // "rgb(15 179 239)",
            // "rgb(55 190 239)",
            // "rgb(112 208 243)",
            // "rgb(159 219 241)",
            // "rgb(191 225 237)",
            // 'rgba(47,74,118, 0.2)', 'rgba(47,74,118, 1)'
            // 'rgba(0,96,208, 0.1)', 'rgba(0,96,208, 0.2)',
            // 'rgba(0,96,208, 0.4)', 'rgba(0,96,208, 0.6)',
            // 'rgba(0,96,208, 0.8)', 'rgba(0,96,208, 1)'
          ].reverse(),
        },
      },
      axisLabel: {
        show: false,
      },
      axisLine: {
        show: true,
        lineStyle: {
          color: "rgba(0,233,234,0.3)",
        },
      },
      splitLine: {
        show: true,
        lineStyle: {
          color: ['rgba(108,254,255,0)', 'rgba(108,254,255,0.3)', 'rgba(108,254,255,0.3)', 'rgba(108,254,255,0.3)', 'rgba(108,254,255,0.3)'],
        },
      },
      name: {
        formatter: function(value) {
          var i = contains(dataname, value);
          var percent = datavaule[i];
          var ret = ""; // 拼接加\n返回的类目项
          var maxLength = 6; // 每项显示文字个数
          var valLength = value.length; // X轴类目项的文字个数
          var rowN = Math.ceil(valLength / maxLength); // 类目项需要换行的行数
          if (rowN > 1) {
            // 如果类目项的文字大于6,
            var temp = ""; // 每次截取的字符串
            var start = 0; // 开始截取的位置
            var end = maxLength; // 结束截取的位置
            temp =
              value.substring(start, end) +
              "\n" +
              value.substring(end, valLength);
            ret += temp; // 凭借最终的字符串
            return "{a|" + percent + "}\n" + "{b|" + ret + "}";
          } else {
            return "{a|" + percent + "}\n" + "{b|" + value + "}";
          }
        },
        textStyle: {
          rich: {
            a: {
              color: "#FFFFFF",
              fontSize: 15,
              padding: [0, 0],
              lineHeight: 10,
            },
            b: {
              color: "#CAEEFF",
              fontSize: 15,
              padding: [0, 0],
              lineHeight: 20,
            },
          },
        },
      },
      indicator: indicator,
    },

    series: [{
      type: "radar",
      symbol: "circle",
      symbolSize: 1,
      areaStyle: {
        normal: {
          color: "#fff",
        },
      },
      itemStyle: {
        color: "#84E1FF",
        borderColor: "#00A7FE",
        borderWidth: 1,
      },
      areaStyle: {
        normal: {
          color: {
            type: "radial",
            colorStops: [{
              offset: 0,
              color: 'rgba(108,254,255,0)'
            }, {
              offset: 1,
              color: 'rgba(108,254,255,0.8)'
            }],
            globalCoord: false
          }
        }
      },
      lineStyle: {
        normal: {
          color: "#234b7f",
          width: 1,
        },
      },
      data: [datavaule],
    }],
  };

}